import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export interface SegmentedToggleItem<TId extends string = string> {
    id: TId;
    labelKey: string;
    hidden?: boolean;
}

/**
 * A pill-style segmented toggle control.
 *
 * @template {string} TId Strongly types the active id and the emitted value.
 */
@Component({
    selector: 'app-segmented-toggle',
    templateUrl: './segmented-toggle.component.html',
    styleUrls: ['./segmented-toggle.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
    ],
})
export class SegmentedToggleComponent<TId extends string = string> {
    @Input({ required: true }) items!: ReadonlyArray<SegmentedToggleItem<TId>>;
    @Input({ required: true }) activeId!: TId;

    @Output() itemClick = new EventEmitter<TId>();

    onItemClick(item: SegmentedToggleItem<TId>): void {
        if (item.hidden) return;
        if (item.id === this.activeId) return;
        this.itemClick.emit(item.id);
    }
}
